// Central content + asset registry for PrzyStań w ciszy
// All user-visible strings are in Polish.

export const SITE = {
  name: "PrzyStań w Ciszy",
  tagline: "Posłuchaj ciszy nad Wisłą",
  location: "Kozielec 38C, 86-022 Kozielec",
  contact: {
    email: "rezerwacja@przystanwciszy.pl",
    phone: "+48 693 030 102",
  },
  socials: {
    instagram: "https://www.instagram.com/przystanwciszy/",
  },
  booking: {
    direct: "#kontakt",
    booking: "https://www.booking.com/hotel/pl/przystan-w-ciszy.pl.html",
    airbnb: "https://www.airbnb.pl/rooms/1671953358179322645?check_in=2026-08-30&check_out=2026-09-04&guests=1&adults=1&s=67&unique_share_id=414237cf-4910-4cb0-9054-ae79b765d181",
    slowhop: "#",
  },
  // Google Maps embed — Kozielec 38C
  mapEmbed:
    "https://www.google.com/maps?q=Kozielec%2038C%2C%2086-022%20Kozielec&output=embed",
  // Przewodnik PDF z gotowymi trasami (rowerowe, piesze, do biegania) — Strava
  guidePdf: "/przewodnik-przystan-w-ciszy.pdf",
  strava: "https://www.strava.com/",
};

// User-provided images (from asset upload)
export const ASSETS = {
  logo: "/images/logo-crane.png",
  heroHouse:
    "https://customer-assets.emergentagent.com/job_crane-cottage-rest/artifacts/wf50broc_IMG_1929.jpeg",
  storyCabin: "/images/story-cabin.webp",
  cottageKitchen: "/images/cottage-kitchen.jpg",
  cottageLiving: "/images/cottage-living.jpg",
  cottageDesk: "/images/cottage-desk.jpg",
  cottageBedroom: "/images/cottage-bedroom.jpg",
  riverFromTerrace:
    "https://customer-assets.emergentagent.com/job_db7eba6b-525c-4664-89e2-bed54e7001de/artifacts/16mo43k2_IMG_5555.jpeg",
  cottageExterior:
    "https://customer-assets.emergentagent.com/job_db7eba6b-525c-4664-89e2-bed54e7001de/artifacts/ery2t1tb_IMG_5550.jpeg",
  cottageTerraceDetail:
    "https://customer-assets.emergentagent.com/job_db7eba6b-525c-4664-89e2-bed54e7001de/artifacts/ucacssel_IMG_5552.jpeg",
  cottageSide:
    "https://customer-assets.emergentagent.com/job_db7eba6b-525c-4664-89e2-bed54e7001de/artifacts/l0enag0m_IMG_5551.jpeg",
  cottageAerial:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/c1ssut0y_dji_fly_20260710_013356_681_1783804683519_photo.webp",
  cottageGrill:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/57nzpj7y_DSC09834.webp",
  cottageDining:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/m9jw8pe6_DSC09840.webp",
  cottageChairs:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/thxv5a80_DSC09849.webp",
  cottageAerialRiver:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/vd7poirk_dji_fly_20260710_171822_647_1783711528073_photo.webp",
  cottageFront:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/48b9j0db_DSC09893.webp",
  cottageInt1:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/3ua2d3nv_DSC09797.webp",
  cottageInt2:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/gw72kftp_DSC09800.webp",
  cottageInt3:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/hnoufstp_DSC09815.webp",
  cottageInt4:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/5sjolglv_DSC09821.webp",
  workationOutdoor:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/vk732unv_DSC00008.webp",
  workationDesk:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/b0kwyde6_DSC00003.webp",
  workationMatcha:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/ergvngp8_DSC09899.webp",
  hosts:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/cczk2v6z_DSC09989.webp",
  dogBolek:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/jzflgazp_DSC09996.webp",
  dogTola:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/snf5aqo7_DSC00016.webp",
  hostsCottage:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/yuij93rk_DSC09971.webp",
  surrRiver:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/9jahi9fr_dji_fly_20260710_013734_692_1783804578999_photo.webp",
  surrAerial:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/z0lp3hy2_dji_fly_20260710_013456_686_1783804657037_photo.webp",
  surrBank:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/4j5yyqpe_dji_fly_20260710_172428_660_1783711588926_photo.webp",
  atmPanorama:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/ift4hp7d_dji_fly_20260710_013740_693_1783804578993_photo.webp",
  atmRiverbank:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/4wlpunax_dji_fly_20260710_172428_660_1783711588926_photo.webp",
  atmCoupleBench:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/2yi63vxb_DSC00013.webp",
  atmFire:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/2ovi0bde_DSC09813.webp",
  atmHerbs:
    "https://customer-assets.emergentagent.com/job_71e55f38-58d2-4e71-9b72-4ffa74dc8891/artifacts/yocz4awz_DSC09827.webp",
  atmBook: "/images/atm-book.webp",
  atmGarden: "/images/atm-garden.webp",
  atmHedgehog: "/images/atm-hedgehog.webp",
  atmCouple: "/images/atm-couple.webp",
  atmSunflowers: "/images/atm-sunflowers.webp",
  atmRunning: "/images/atm-running.webp",
  cottageBedroomGreen: "/images/cottage-bedroom-green.webp",
  cottageWc: "/images/cottage-wc.webp",
  cottageBathroom: "/images/cottage-bathroom.webp",
  cottageLoft: "/images/cottage-loft-v2.webp",
  cottageTwin: "/images/cottage-twin.webp",
  cottageLiving2: "/images/cottage-living2.webp",
  cottageKitchen2: "/images/cottage-kitchen2.webp",
  cottageWardrobe: "/images/cottage-wardrobe.webp",
  surrPath: "/images/surr-path.webp",
  surrFields: "/images/surr-fields.webp",
  byWaterfront: "/images/by1.webp",
  byIce: "/images/by2.webp",
  byTram: "/images/by3.webp",
  byIsland: "/images/by4.webp",
  byStreet: "/images/by5.webp",
  byPromenade: "/images/by6.webp",
};

// Carefully chosen Unsplash/Pexels fills for sections without user photos
export const STOCK = {
  hero:
    "https://images.unsplash.com/photo-1701187260623-55d46f4821ac?auto=format&fit=crop&w=2400&q=85",
  riverMist:
    "https://images.pexels.com/photos/19236445/pexels-photo-19236445.jpeg?auto=compress&cs=tinysrgb&w=2000",
  interiorWarm:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1600&q=85",
  coffeeMorning:
    "https://images.unsplash.com/photo-1481833761820-0509d3217039?auto=format&fit=crop&w=1600&q=85",
  firepit:
    "https://images.unsplash.com/photo-1470246973918-29a93221c455?auto=format&fit=crop&w=1600&q=85",
  bicycles:
    "https://images.unsplash.com/photo-1505705694340-019e1e335916?auto=format&fit=crop&w=1600&q=85",
  massage:
    "https://images.unsplash.com/photo-1600334129128-685c5582fd35?auto=format&fit=crop&w=1600&q=85",
  honey:
    "https://images.unsplash.com/photo-1587049352846-4a222e784d38?auto=format&fit=crop&w=1600&q=85",
  workation:
    "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?auto=format&fit=crop&w=1600&q=85",
  hosts:
    "https://images.unsplash.com/photo-1518882570151-ca74c6ca9cf7?auto=format&fit=crop&w=1600&q=85",
  surroundings:
    "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1600&q=85",
  kayak:
    "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?auto=format&fit=crop&w=1600&q=85",
  vineyard:
    "https://images.unsplash.com/photo-1506157786151-b8491531f063?auto=format&fit=crop&w=1600&q=85",
  window:
    "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1600&q=85",
};

export const STORY_WORDS = [
  "cisza",
  "przestrzeń",
  "natura",
  "światło",
  "dźwięki natury",
  "zwolnienie",
  "reset",
];

export const REVIEWS = [
  {
    quote:
      "Spędziliśmy tutaj rodzinny pobyt i jesteśmy zachwyceni. Ogromnym atutem są przepiękne widoki oraz absolutna cisza, która pozwala naprawdę odpocząć i oderwać się od codziennego zgiełku.",
    author: "Bartłomiej",
  },
  {
    quote:
      "PrzyStań w Ciszy może być świetną bazą wypadową do zwiedzania regionu (Park Krajobrazowy Doliny Dolnej Wisły to ukryta perełka!). Można rozważyć pracę zdalną — stabilne WiFi.",
    author: "Karolina",
  },
  {
    quote:
      "Poranek na tarasie plus koncert ptaków koi każde nerwy. Byłem w wielu miejscach, ale tu na 100% wrócimy.",
    author: "Michał",
  },
];


export const COTTAGE_FEATURES = [
  {
    title: "Dom na wyłączność",
    desc: "Nie udostępniamy pokoi, tylko całą przestrzeń. Dla Twojego komfortu.",
  },
  {
    title: "Maksymalnie 6 gości",
    desc: "Możesz przyjechać solo, ze swoją drugą połówką, z rodziną, ze znajomymi.",
  },
  {
    title: "Dwie sypialnie",
    desc: "4 pojedyncze łóżka lub 2 podwójne — daj nam znać o swoich potrzebach. W pierwszej sypialni łóżka 2×90 cm (lub złączone 180 cm), w drugiej 2×80 cm (lub złączone 160 cm).",
  },
  {
    title: "W pełni wyposażona łazienka",
    desc: "Prysznic, ubikacja, umywalka, pralka. Ręczniki, suszarka i przybory toaletowe.",
  },
  {
    title: "Kuchnia, w której poczujesz się jak w domu",
    desc: "Ugotujesz w niej obiad, przygotujesz śniadanie i poranną kawę. Zawiera wszystkie niezbędne sprzęty: lodówka, piekarnik, kuchnia indukcyjna, zmywarka, czajnik, spieniacz do mleka, kawiarka, filtr do wody, a nawet odkurzacz.",
  },
  {
    title: "Salon",
    desc: "Śniadanie z widokiem na Wisłę przy rodzinnym stole. Ale jest też telewizor, jeśli nie chcesz rezygnować ze swojego ulubionego serialu i wygodna kanapa, na której mogą spać dwie osoby.",
  },
  {
    title: "Klimatyzacja",
    desc: "Latem ochłodzi, a zimą ogrzeje.",
  },
  {
    title: "Taras z widokiem na Wisłę",
    desc: "Ciesz się poranną kawą, kiedy rosa jeszcze leży na trawie, a nad rzeką unosi się mgła. Delektuj się wieczornymi rozmowami w akompaniamencie świerszczy.",
  },
  {
    title: "Miejsce na grilla",
    desc: "Poczuj ciepło ognia, zapach drewna i długie rozmowy pod gwieździstym niebem.",
  },
];

export const ACTIVITIES_INCLUDED = [
  "4 rowery do Twojej dyspozycji",
  "Gotowe trasy piesze, rowerowe i na orientację",
  "Hamaki i leżaki",
  "Badminton",
  "Gry planszowe i książki",
  "Możliwość poznania uli i pszczół",
  "Degustacja miodu z naszej pasieki",
];

export const ACTIVITIES_PAID = [
  {
    title: "Śniadania",
    desc: "Ze swojskimi i lokalnymi produktami — gotowe na poranek nad Wisłą.",
  },
  { title: "Masaż lomi lomi nui", desc: "Głęboko relaksujący masaż hawajski." },
  { title: "Zabiegi na twarz", desc: "DRE multilayer lifting, refleksologia twarzy." },
];

export const SURROUNDINGS = [
  {
    title: "Grodzisko Talerzyk",
    km: "ok. 2 km",
    desc: "Pozostałości dawnego grodziska skrywają jeden z najpiękniejszych punktów widokowych w okolicy. Rozciąga się stąd panorama Doliny Dolnej Wisły, a krótki spacer łączy historię z wyjątkowym krajobrazem.",
  },
  {
    title: "Parów Cieleszyński",
    km: "ok. 4 km",
    desc: "Leśny wąwóz dla tych, którzy lubią zejść z utartego szlaku. Wysokie zbocza, cień drzew i naturalny krajobraz sprawiają, że nawet krótki spacer daje poczucie prawdziwego kontaktu z naturą.",
  },
  {
    title: "Chata Mennonicka w Chrystkowie",
    km: "ok. 5 km",
    desc: "Jedna z najlepiej zachowanych chat olęderskich w Polsce. To miejsce pozwala zobaczyć, jak wyglądało życie dawnych osadników nad Wisłą i lepiej zrozumieć historię całej doliny.",
  },
  {
    title: "Ostromecko",
    km: "ok. 12 km",
    desc: "Zespół pałacowo-parkowy z dwoma pałacami, rozległym parkiem i spokojnymi alejkami spacerowymi. Idealny kierunek na leniwe popołudnie, gdy chcecie połączyć naturę, historię i odrobinę elegancji.",
  },
  {
    title: "Winnice Doliny Dolnej Wisły",
    km: "ok. 18 km",
    desc: "Nadwiślańskie zbocza coraz częściej kojarzone są z lokalnym winem. Kameralne winnice zapraszają na degustacje i spotkania z właścicielami, którzy z pasją opowiadają o uprawie winorośli i charakterze tego regionu.",
  },
  {
    title: "Świecie nad Wisłą",
    km: "ok. 26 km",
    desc: "Miasto z charakterystycznym zamkiem krzyżackim, spokojną starówką i nadrzecznymi bulwarami. To dobry kierunek na półdniową wycieczkę dla osób, które lubią odkrywać historię w nieco spokojniejszym tempie.",
  },
  {
    title: "Luszkowo",
    km: "ok. 28 km",
    desc: "Niewielka nadwiślańska wieś położona na wysokiej skarpie. Przyjedźcie tu dla ciszy, rozległych widoków na dolinę i spokojnego spaceru z dala od popularnych atrakcji.",
  },
  {
    title: "Chełmno",
    km: "ok. 35 km",
    desc: "Jedno z najpiękniejszych średniowiecznych miast w Polsce, nazywane Miastem Zakochanych. Gotyckie kościoły, niemal kompletne mury obronne i klimatyczne uliczki sprawiają, że warto zaplanować tu przynajmniej pół dnia. To idealne zwieńczenie wycieczek po Dolinie Dolnej Wisły.",
  },
];

export const BYDGOSZCZ = {
  intro: {
    lead: "Najciekawsze atrakcje Bydgoszczy zaledwie 30 minut od PrzyStań w Ciszy.",
    body: "Jeśli podczas pobytu zapragniecie miejskich spacerów, kultury lub dobrej kawy, Bydgoszcz jest dosłownie na wyciągnięcie ręki. To miasto, które od lat rozwija się wokół rzeki Brdy i zachwyca połączeniem zabytkowej architektury, zieleni oraz nowoczesnych przestrzeni. Przygotowaliśmy miejsca, do których sami chętnie wracamy.",
  },
  walks: [
    {
      title: "Wyspa Młyńska i Młyny Rothera",
      desc: "Jeśli zastanawiacie się, co zobaczyć w Bydgoszczy, właśnie od tego miejsca warto zacząć. Wyspa Młyńska to zielone serce miasta, idealne na spacer, piknik czy chwilę odpoczynku nad wodą. W otoczeniu zabytkowych spichlerzy i mostków znajduje się nowoczesne centrum kultury — Młyny Rothera, gdzie warto wejść na bezpłatny taras widokowy i zobaczyć panoramę Bydgoszczy z góry. To także świetne miejsce na wystawy, kawę i wydarzenia kulturalne.",
      image: "byIsland",
      alt: "Wyspa Młyńska w Bydgoszczy — Młyny Rothera i Opera Nova nad Brdą",
    },
    {
      title: "Wenecja Bydgoska",
      desc: "Tuż obok Wyspy Młyńskiej płynie Młynówka — odnoga Brdy otoczona zabytkowymi kamienicami i klimatycznymi mostkami. To właśnie stąd wzięło się określenie Wenecja Bydgoska. Spacer tą częścią miasta szczególnie pięknie wygląda o poranku i tuż przed zachodem słońca.",
      image: "byPromenade",
      alt: "Bulwary nad Brdą w Bydgoszczy z rzeźbą „Przechodząca przez rzekę”",
    },
    {
      title: "Stary Fordon",
      desc: "Historyczna dzielnica położona nad Wisłą przeszła w ostatnich latach dużą rewitalizację. Warto przespacerować się rynkiem, zajrzeć do kościoła św. Mikołaja, odkryć urokliwe uliczki i dojść aż do nadwiślańskiego bulwaru. To spokojniejsza, mniej oczywista twarz Bydgoszczy, którą szczególnie polecamy osobom szukającym miejsc poza głównym szlakiem turystycznym.",
    },
    {
      title: "Dzielnica Muzyczna i Sielanka",
      desc: "To jedna z najbardziej eleganckich części miasta. Spacer warto rozpocząć przy Placu Wolności i Fontannie Potop, następnie przejść obok Filharmonii Pomorskiej i Parku Kochanowskiego aż do Ogrodu Botanicznego. Po drodze czeka ulica Cieszkowskiego z pięknymi secesyjnymi kamienicami oraz spokojna Sielanka — osiedle zabytkowych willi, które zachowało swój przedwojenny charakter.",
      image: "byStreet",
      alt: "Secesyjne kamienice przy eleganckiej uliczce w Dzielnicy Muzycznej w Bydgoszczy",
    },
  ],
  museums: [
    {
      title: "Exploseum",
      desc: "Jedna z najbardziej niezwykłych atrakcji w Bydgoszczy i prawdziwa gratka dla miłośników historii. Muzeum powstało na terenie dawnej fabryki materiałów wybuchowych DAG Fabrik Bromberg. Trasa prowadzi przez betonowe tunele ukryte w lesie i opowiada historię miejsca, które do dziś robi ogromne wrażenie swoją skalą.",
    },
    {
      title: "Muzeum Mydła i Historii Brudu",
      desc: "To jedno z najbardziej oryginalnych muzeów w Polsce. Zwiedzanie kończy się warsztatami, podczas których każdy uczestnik może własnoręcznie wykonać mydło. Świetna propozycja zarówno dla dorosłych, jak i dzieci.",
    },
    {
      title: "Wieża Ciśnień i Muzeum Wodociągów",
      desc: "Jedno z najlepszych miejsc widokowych w Bydgoszczy. Po wejściu na szczyt rozciąga się panorama miasta, a w środku można poznać historię bydgoskich wodociągów i rozwoju miasta. Jeśli lubicie mniej oczywiste atrakcje, koniecznie wpiszcie to miejsce na swoją listę.",
    },
    {
      title: "Muzea na Wyspie Młyńskiej",
      desc: "Jeżeli pogoda nie dopisze, warto zostać na Wyspie Młyńskiej nieco dłużej. W niewielkiej odległości znajdują się Muzeum Archeologiczne, Europejskie Centrum Pieniądza oraz galerie sztuki, dzięki czemu można spędzić tutaj nawet całe popołudnie.",
    },
  ],
  activities: [
    {
      title: "Bydgoszcz od strony rzeki",
      desc: "To właśnie woda nadaje Bydgoszczy jej wyjątkowy charakter. Możecie wybrać się w rejs tramwajem wodnym, wypożyczyć kajak i zobaczyć miasto z perspektywy Brdy lub po prostu przespacerować się bulwarami ciągnącymi się wzdłuż rzeki. To jedna z najprzyjemniejszych form zwiedzania miasta, szczególnie latem.",
    },
    {
      title: "Dla aktywnych",
      desc: "Jeśli lubicie aktywny wypoczynek, warto odwiedzić Myślęcinek — największy park miejski w Polsce. Znajdziecie tam liczne trasy spacerowe i rowerowe, ogród botaniczny oraz wiele terenów rekreacyjnych. Dobrym pomysłem jest także spacer wzdłuż Kanału Bydgoskiego, który od lat pozostaje jednym z ulubionych miejsc mieszkańców.",
    },
  ],
  taste: {
    title: "Smaki Bydgoszczy",
    desc: "Spacer po centrum najlepiej zakończyć lodami w kultowym Przesmyku. Wśród sezonowych smaków często pojawiają się kompozycje inspirowane Bydgoszczą, które stały się lokalną ciekawostką i są chętnie polecane przez mieszkańców.",
    image: "byIce",
    alt: "Lody o smaku „Bydgoskie” w bydgoskiej lodziarni",
  },
};

export const TORUN = {
  intro: {
    subtitle: "Około 40 minut od PrzyStań w Ciszy",
    body: "Jedno z najlepiej zachowanych średniowiecznych miast w Europie i obowiązkowy punkt podczas pobytu w Dolinie Dolnej Wisły. Jeśli zastanawiacie się, co zobaczyć w Toruniu, wystarczy jeden dzień, by odkryć jego najpiękniejsze zakątki — od gotyckiej starówki wpisanej na Listę Światowego Dziedzictwa UNESCO po miejsca związane z Mikołajem Kopernikiem i słynnymi toruńskimi piernikami.",
  },
  images: {
    town:
      "https://images.pexels.com/photos/28729445/pexels-photo-28729445.jpeg?auto=compress&cs=tinysrgb&w=1400",
    townAlt: "Ratusz Staromiejski i Rynek Staromiejski w Toruniu",
    piernik:
      "https://images.unsplash.com/photo-1610562275255-03b7fa0d4655?auto=format&fit=crop&w=1400&q=85",
    piernikAlt: "Ozdobne toruńskie pierniki na talerzu",
  },
  spots: [
    {
      title: "Rynek Staromiejski i Stare Miasto",
      desc: "Najlepsze miejsce, by rozpocząć zwiedzanie Torunia. Spacer wśród gotyckich kamienic, Ratusza Staromiejskiego i pomnika Mikołaja Kopernika pozwala poczuć wyjątkowy klimat miasta. Warto zajrzeć również do malowniczych uliczek prowadzących w stronę Wisły.",
    },
    {
      title: "Krzywa Wieża",
      desc: "Jeden z najbardziej rozpoznawalnych symboli Torunia. Średniowieczna baszta odchyla się od pionu o blisko półtora metra i od wieków jest bohaterką lokalnych legend. To obowiązkowy przystanek podczas spaceru po starówce.",
    },
    {
      title: "Dom Mikołaja Kopernika",
      desc: "Miejsce poświęcone najsłynniejszemu mieszkańcowi Torunia. Interaktywna ekspozycja pozwala poznać życie astronoma oraz historię miasta w czasach hanzeatyckiej świetności.",
    },
    {
      title: "Żywe Muzeum Piernika",
      desc: "Jedna z najpopularniejszych atrakcji Torunia. Podczas warsztatów można własnoręcznie przygotować tradycyjne pierniki według dawnych receptur i poznać historię wypieku, z którego słynie miasto.",
    },
    {
      title: "Planetarium",
      desc: "Nowoczesne pokazy pod kopułą przenoszą w świat astronomii i kosmosu. To świetna propozycja zarówno dla dorosłych, jak i dzieci, szczególnie w deszczowy dzień.",
    },
    {
      title: "Bulwar Filadelfijski i panorama Torunia",
      desc: "Spacer nad Wisłą to doskonałe zwieńczenie wizyty. Z bulwaru rozciąga się piękny widok na gotycką starówkę, a jeśli będziecie mieć chwilę, przejdźcie na drugi brzeg Wisły — właśnie stamtąd rozpościera się jedna z najbardziej charakterystycznych panoram Torunia.",
    },
  ],
};

export const STAY_RULES = [
  {
    title: "Pobyt minimum 2 noce",
    desc: "Zapraszamy na pobyty od dwóch nocy. Wierzymy, że dopiero wtedy można naprawdę zwolnić, poczuć rytm tego miejsca i spokojnie odpocząć.",
  },
  {
    title: "Zameldowanie i wymeldowanie",
    desc: "Czekamy na Was w dniu przyjazdu między 15:00 a 22:00. W dniu wyjazdu prosimy o wymeldowanie do 10:00.",
  },
  {
    title: "Klucze i powitanie",
    desc: "Na powitanie przekazujemy klucze osobiście, żeby przywitać Was na miejscu i pokazać najważniejsze rzeczy. Przy wyjeździe chętnie też się z Wami pożegnamy, ale możecie również zostawić klucze w skrzynce z kodem.",
  },
  {
    title: "Dzieci mile widziane",
    desc: "Zapraszamy rodziny z dziećmi w każdym wieku. Dla najmłodszych gości przygotujemy bezpłatnie łóżeczko.",
  },
  {
    title: "Pobyty bez zwierząt",
    desc: "Choć bardzo kochamy zwierzaki, prosimy o przyjazd bez pupili. Na miejscu mieszkają nasze dwa pieski, Bolek i Tola, dlatego chcemy zadbać o spokój i bezpieczeństwo wszystkich.",
  },
  {
    title: "Zakaz palenia w domku",
    desc: "W domku obowiązuje zakaz palenia. Prosimy o uszanowanie tej zasady, żeby wnętrze pozostało świeże, przyjemne i komfortowe dla wszystkich gości.",
  },
  {
    title: "Bez imprez, z szacunkiem dla ciszy",
    desc: "To miejsce stworzone do spokojnego odpoczynku blisko natury, dlatego nie ma możliwości organizowania imprez. Prosimy też o zachowanie ciszy nocnej od 22:00 do 7:00 i uszanowanie spokojnego rytmu okolicy.",
  },
  {
    title: "Parking na miejscu",
    desc: "Na miejscu czeka na Was prywatny, bezpłatny parking.",
  },
];
